const Model = require("../types/Model");
// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;
const par = require("par");
const rPar = par.rpartial;

const SENT_TIME = 5000;

module.exports = Model({
	name: "accountswitcher",
	init,
	triggers,
	listeners,

	reset
});

function listeners(){
	return {
		"personal:updated": handle_personal_update
	};
}

function triggers(){
	return {
		switchAccount: switchAccount,
		returnAccount: returnAccount,
		login: loginAccount,
		reset: reset,
		forgot: forgotPassword
	};
}

function init(){
	var update = {
		email: null,
		errors: null
	};
	this._timeout = null;
	this._personal = {};
	AsyncStorage.getItem("parent").then((parent) => {
		update.hasParent = !!parent;
		this.push(update);
	});
}

function switchAccount(data){
	const {who} = data;
	this.emit("usermetrics:trigger:track", "switch to patient account", {
		who: who._id
	});
	return this.api.org.users.token(who)
		.then(handleGotToken.bind(this));
}

function handleGotToken(data){
	const personal = this._personal;
	const email = personal.email;
	const {token} = data;
	return setOldToken(email)
		.then(par(setNewToken, token))
		.then(emitRefresh.bind(this));
}

function setOldToken(email){
	return AsyncStorage.setItem("parent", email);
}

function setNewToken(token){
	return AsyncStorage.setItem("token", token);
}

function emitRefresh(){
	this.emit("refresh:trigger:refresh");
}

function returnAccount(){
	this.emit("usermetrics:trigger:track", "attempt to return to parent account");
	return AsyncStorage.getItem("parent")
		.then(email => this.extend({email}));
}

function loginAccount(data){
	const {password} = data;

	return AsyncStorage.getItem("parent")
		.then(rPar(this.api.auth.login, password))
		.then(handleSuccess.bind(this))
		.catch(handleFail.bind(this));
}

function handleFail(){
	this.extend({
		errors: "login.loginerror2"
	});
	this.emit("usermetrics:trigger:track", "fail to return to parent account");
}

function handleSuccess(data){
	const {token} = data;

	this.reset();

	this.emit("usermetrics:trigger:track", "return to parent account");

	return setNewToken(token)
		.then(clearParent)
		.then(emitRefresh.bind(this));
}

function reset(){
	this.extend({
		email: null,
		errors: null,
		sent: false
	});
}

function clearParent(){
	return AsyncStorage.removeItem("parent");
}

function forgotPassword(){
	var email = this.data.email;
	this.emit("usermetrics:trigger:track", "forgot password in account switcher");
	if(!email) return;
	return this.api.auth.password.request(email)
		.then(() => {
			this.extend({
				sent: true
			});
			this._timeout = setTimeout(clearSent.bind(this), SENT_TIME);
		});
}

function clearSent(){
	clearTimeout(this._timeout);
	this._timeout = null;
	this.extend({
		sent: false
	});
}

function handle_personal_update(data){
	this._personal = data;
}